<template>
  <v-jumbotron :gradient="gradient" dark height="100%">
    <v-progress-linear id="loader" :indeterminate="true"></v-progress-linear>
    <v-container fill-height class="login-bg">
      <v-layout align-center justify-center>
        <v-flex xs12 class="nome-empresa">
          <img src="../assets/a5-logo.svg" alt="logo" class="logo">
          <h2>Sistema A5 Convites<br /> Para continuar, faça login.</h2>
          <div id="firebaseui-auth-container"></div>
        </v-flex>
      </v-layout>
    </v-container>
  </v-jumbotron>
</template>

<script>
// import firebaseui from "firebaseui/dist/npm__pt.js";
import firebaseui from "firebaseui/dist/npm__pt";
import firebase from "firebase";

export default {
  name: "auth",
  data: () => ({
    gradient: "to top, #7BA4EF, #233B8A"
  }),
  mounted() {
    var uiConfig = {
      callbacks: {
        // eslint-disable-next-line
        signInSuccess: function (currentUser, credential, redirectUrl) {
          // Do something.
          // Return type determines whether we continue the redirect automatically
          // or whether we leave that to developer to handle.
          return true;
        },
        uiShown: function() {
          // The widget is rendered.
          // Hide the loader.
          document.getElementById("loader").style.display = "none";
        }
      },
      credentialHelper: firebaseui.auth.CredentialHelper.NONE,
      signInSuccessUrl: "/",
      signInFlow: "redirect",
      signInOptions: [
        firebase.auth.EmailAuthProvider.PROVIDER_ID,
        firebase.auth.GoogleAuthProvider.PROVIDER_ID,
        {
          provider: firebase.auth.FacebookAuthProvider.PROVIDER_ID,
          scopes: ["public_profile", "email"]
        }
      ]
    };
    var ui = new firebaseui.auth.AuthUI(this.$auth);
    ui.start("#firebaseui-auth-container", uiConfig);
    this.$auth.onAuthStateChanged(user => {
      if (user) {
        this.$router.push({ path: "/" });
      }
    });
  }
};
</script>

<style lang="stylus" scoped>
@import '~firebaseui/dist/firebaseui.css';

.login {
  background-color: #627eaf;
}

.login-bg {
  background-size: contain;
  background: url('../assets/bg-capelos.svg') no-repeat fixed top;

  @media screen and (min-width: 800px) {
    background-size: contain;
  }
}

.logo {
  width: 300px;
  margin-bottom: 0px;

  @media screen and (min-width: 800px) {
    width: 400px;
  }
}

.nome-empresa {
  position: fixed;
  bottom: 50px;
  color: #333;
  text-align: center;
  width: 100%;

  h1 {
    font-size: 50px;

    @media screen and (min-width: 800px) {
      font-size: 70px;
    }
  }

  h2 {
    color: #ffffff;
    font-size: 18px;
    line-height: 1.1;

    @media screen and (min-width: 800px) {
      font-size: 26px;
    }
  }
}

#firebaseui-auth-container {
  text-align: center;
  width: 100%;
  background-color: transparent;
}
</style>



// WEBPACK FOOTER //
// src/views/AppLogin.vue